 import { getParticipantesSorteo } from "@helpers/httpRequests/httpRequestsGruposLectura/httpRequestsGruposLectura";
import React, { useEffect, useState } from "react";
import { arregloLecturas } from "../utils/lecturas";
import { Image } from "react-bootstrap";

const mockParticipantes = [
    {
        apellidos: 'Mendez',
        nombreCompleto: 'Victor',
        enSemifinal: 1,
        enFinal: 1,
        idEjercicio: 22,
        idLectura: 22,
        idPerfil: 6,
        municipio: 'León',
        plantel: 'Telebachillerato Global Click',
        nombreDocente: 'Maricela Perez'
    },
    {
        apellidos: 'Ornelas',
        nombreCompleto: 'Gabriela',
        enSemifinal: 1,
        enFinal: 1,
        idEjercicio: 13,
        idLectura: 13,
        idPerfil: 4423,
        municipio: 'León',
        plantel: 'Telebachillerato Global Click',
        nombreDocente: 'Maricela Perez'
    },
    {
        apellidos: 'Jimenez',
        nombreCompleto: 'Oswaldo',
        enSemifinal: 1,
        enFinal: 1,
        idEjercicio: 11,
        idLectura: 11,
        idPerfil: 6312,
        municipio: 'León',
        plantel: 'Telebachillerato Global Click',
        nombreDocente: 'Maricela Perez'
    },
    {
        apellidos: 'Pau',
        nombreCompleto: 'Pau',
        enSemifinal: 1,
        enFinal: 1,
        idEjercicio: 9,
        idLectura: 9,
        idPerfil: 6,
        municipio: 'León',
        plantel: 'Telebachillerato Global Click',
        nombreDocente: 'Maricela Perez'
    },
]

const COLORS = ["#ff9900", "#00152a", "#212529", "#ffffff"];
const SPIN_DURATION_MS = 4000;

function construirFondoRuleta(segmentos) {
  const porcion = 360 / segmentos;
  const paradas = [];
  for (let i = 0; i < segmentos; i++) {
    const color = COLORS[i % COLORS.length];
    paradas.push(`${color} ${i * porcion}deg ${(i + 1) * porcion}deg`);
  }
  return `conic-gradient(${paradas.join(", ")})`;
}

const GLOBAL_STYLES = `
@keyframes ruleta-fade-in-up { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
@keyframes ruleta-pulse-glow { 0%, 100% { box-shadow: 0 0 0 0 rgba(255,153,0,0.55); } 50% { box-shadow: 0 0 0 16px rgba(255,153,0,0); } }
@keyframes ruleta-spin-loader { to { transform: rotate(360deg); } }
@keyframes ruleta-ring-spin { to { transform: rotate(360deg); } }
@keyframes ruleta-btn-idle-pulse { 0%, 100% { box-shadow: 0 0 0 0 rgba(255,153,0,0.5); } 50% { box-shadow: 0 0 0 12px rgba(255,153,0,0); } }
@keyframes ruleta-confeti-fall { 0% { transform: translateY(-20px) rotate(0deg); opacity: 1; } 100% { transform: translateY(460px) rotate(540deg); opacity: 0; } }
.ruleta-scroll { scrollbar-width: thin; scrollbar-color: #ff9900 #00152a; }
.ruleta-scroll::-webkit-scrollbar { width: 10px; }
.ruleta-scroll::-webkit-scrollbar-track { background: #00152a; border-radius: 8px; }
.ruleta-scroll::-webkit-scrollbar-thumb { background: #ff9900; border-radius: 8px; }
.ruleta-boton-girar:not(:disabled):hover { transform: translateY(-2px); box-shadow: 0 6px 18px rgba(255,153,0,0.45); }
.ruleta-boton-girar:not(:disabled):active { transform: translateY(0) scale(0.98); }
.ruleta-boton-girar--idle { animation: ruleta-btn-idle-pulse 2.2s ease-in-out infinite; }
.ruleta-resultado-card { animation: ruleta-fade-in-up 0.45s ease-out, ruleta-pulse-glow 1.6s ease-out; }
.ruleta-loader { animation: ruleta-spin-loader 0.9s linear infinite; }
.ruleta-ring { position: relative; }
.ruleta-ring::before {
  content: "";
  position: absolute;
  inset: -18px;
  border-radius: 50%;
  background: conic-gradient(from 0deg, #ff9900, transparent 60%, #ff9900);
  animation: ruleta-ring-spin 6s linear infinite;
  filter: blur(3px);
  opacity: 0.55;
  z-index: 0;
}
.ruleta-confeti {
  position: absolute;
  top: -20px;
  width: 8px;
  height: 14px;
  opacity: 0.95;
  animation-name: ruleta-confeti-fall;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
  pointer-events: none;
}
.ruleta-grid {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;
  max-width: 1080px;
  transition: gap 0.7s ease;
}
.ruleta-grid--solo {
  gap: 0px;
}
.ruleta-panel {
  opacity: 1;
  max-height: 2000px;
  margin-top: 0;
  transform: translateY(0);
  transition: opacity 0.6s ease 1.5s, max-height 0.7s ease, margin-top 0.7s ease, transform 0.6s ease 1.5s;
}
.ruleta-grid--solo .ruleta-panel {
  opacity: 0;
  max-height: 0;
  margin-top: -20px;
  transform: translateY(16px);
  overflow: hidden;
  pointer-events: none;
  transition: opacity 0.3s ease, max-height 0.7s ease, margin-top 0.7s ease, transform 0.3s ease;
}
@media (min-width: 900px) {
  .ruleta-grid { flex-direction: row; align-items: flex-start; justify-content: center; }
  .ruleta-stage { flex: 0 0 400px; transition: flex-basis 0.7s ease; }
  .ruleta-panel { flex: 1 1 420px; max-width: 460px; max-height: none; }
  .ruleta-grid--solo .ruleta-panel { flex-basis: 0; max-width: 0; margin-top: 0; }
  .ruleta-grid--solo .ruleta-stage { flex: 0 0 400px; margin: 0 auto; }
}
`;

const estilos = {
  contenedor: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 32,
    padding: 40,
    backgroundImage: "radial-gradient(circle at 50% 0%, #1b2330 0%, #212529 55%, #00152a 100%)",
    color: "#ffffff",
    fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    borderRadius: 0,
    height: "100vh",
    width: "100%",
    boxSizing: "border-box",
    overflowY: "auto",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
    textAlign: "center",
  },
  headerTitulo: {
    margin: 0,
    fontSize: 38,
    fontWeight: 800,
    letterSpacing: 1,
    backgroundImage: "linear-gradient(90deg, #ffffff, #ff9900)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  headerSubtitulo: {
    margin: 0,
    fontSize: 15,
    color: "rgba(255,255,255,0.55)",
  },
  stage: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 20,
    position: "relative",
    width: "100%",
  },
  panel: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 20,
    width: "100%",
  },
  confetiCapa: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    overflow: "hidden",
    pointerEvents: "none",
    zIndex: 4,
  },
  instruccion: {
    fontSize: 13,
    color: "rgba(255,255,255,0.5)",
    textAlign: "center",
  },
  ruletaWrapper: {
    position: "relative",
    width: 360,
    height: 360,
    flexShrink: 0,
  },
  puntero: {
    position: "absolute",
    top: -10,
    left: "50%",
    transform: "translateX(-50%)",
    width: 0,
    height: 0,
    borderLeft: "16px solid transparent",
    borderRight: "16px solid transparent",
    borderTop: "28px solid #ff9900",
    zIndex: 2,
    filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.5))",
  },
  ruleta: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    border: "8px solid #ffffff",
    boxShadow: "0 0 0 4px #00152a, 0 0 40px rgba(255,153,0,0.35), 0 10px 30px rgba(0,0,0,0.6)",
    transition: `transform ${SPIN_DURATION_MS}ms cubic-bezier(0.17, 0.67, 0.12, 0.99)`,
  },
  centro: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: 56,
    height: 56,
    marginTop: -28,
    marginLeft: -28,
    borderRadius: "50%",
    backgroundColor: "#ff9900",
    border: "4px solid #ffffff",
    zIndex: 3,
  },
  boton: (deshabilitado) => ({
    padding: "14px 32px",
    fontSize: 17,
    fontWeight: "bold",
    color: deshabilitado ? "#888" : "#212529",
    backgroundColor: deshabilitado ? "#555" : "#ff9900",
    border: "none",
    borderRadius: 8,
    cursor: deshabilitado ? "not-allowed" : "pointer",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
  }),
  progreso: {
    fontSize: 15,
    fontWeight: "bold",
    color: "#212529",
    backgroundColor: "#ff9900",
    padding: "8px 20px",
    borderRadius: 999,
    letterSpacing: 0.5,
  },
  loaderWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 16,
    padding: 40,
  },
  loader: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    border: "6px solid rgba(255,153,0,0.25)",
    borderTopColor: "#ff9900",
  },
  errorBox: {
    width: "100%",
    maxWidth: 460,
    backgroundColor: "#00152a",
    border: "2px solid #ff9900",
    borderRadius: 12,
    padding: "16px 20px",
    color: "#ffffff",
    textAlign: "center",
  },
  tarjetaResultado: {
    width: "100%",
    maxWidth: 460,
    backgroundColor: "#00152a",
    border: "2px solid #ff9900",
    borderRadius: 12,
    padding: 24,
    boxShadow: "0 12px 30px rgba(0,0,0,0.4)",
  },
  historialPanel: {
    width: "100%",
    maxWidth: 460,
    maxHeight: 180,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 8,
    padding: "4px 4px 4px 0",
  },
  historialItem: {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    backgroundColor: "#00152a",
    border: "1px solid rgba(255,153,0,0.4)",
    borderRadius: 8,
    padding: "8px 14px",
    fontSize: 13,
  },
  historialNombre: {
    color: "#ffffff",
    fontWeight: "bold",
  },
  historialLectura: {
    color: "#ff9900",
    textAlign: "right",
  },
  filaResultado: {
    display: "flex",
    justifyContent: "space-between",
    padding: "4px 0",
    gap: 20,
    borderBottom: "1px solid rgba(255,255,255,0.1)",
  },
  etiqueta: {
    color: "#ff9900",
    fontWeight: "bold",
  },
  tituloResultado: {
    margin: "0 0 14px",
    color: "#ff9900",
    textAlign: "center",
    fontSize: 26,
    fontWeight: 800,
  },
  finalizado: {
    color: "#ff9900",
    fontWeight: "bold",
    fontSize: 18,
  },
};

/**
 * @param {Array} participantes - arreglo de objetos con apellidos, enFinal, enSemifinal,
 *   idEjercicio, idLectura, idPerfil, municipio, nombreCompleto, nombreDocente, plantel
 * @param {Array} lecturas - arreglo externo indexado por idLectura (lecturas[idLectura] = titulo)
 * @param {Function} [onTerminar] - callback opcional, recibe el historial completo al acabar el sorteo
 */
export default function RuletaSorteo({ participantes = [], lecturas = arregloLecturas, onTerminar }) {
  const [indice, setIndice] = useState(0);
  const [rotacion, setRotacion] = useState(0);
  const [girando, setGirando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [estudiantes, setEstudiantes] = useState(mockParticipantes);


  const total = estudiantes.length;
  const terminado = indice >= total;
  const segmentos = Math.max(total, 12);
  const fondoRuleta = construirFondoRuleta(segmentos);

  const girar = () => {
    if (girando || terminado) return;
    setGirando(true);
    setResultado(null);
    const vueltasExtra = 360 * 5;
    const anguloAleatorio = Math.floor(Math.random() * 360);
    setRotacion((prev) => prev + vueltasExtra + anguloAleatorio);
  };

  const manejarFinGiro = () => {
    if (!girando) return;
    const participante = estudiantes[indice];
    console.log(participante)
    // const {data} = participante;
    const indiceParticipante = participante.idLectura;
    // const indiceParticipante = participante.idLectura;
    const tituloLectura = arregloLecturas[indiceParticipante].titulo ?? null;
    const resultadoActual = { ...participante, tituloLectura };
    // const resultadoActual = { ...participante, tituloLectura };
    console.log(resultadoActual)

    setResultado(resultadoActual);
    setHistorial((prev) => {
      const nuevoHistorial = [...prev, resultadoActual];
      if (indice + 1 >= total && onTerminar) onTerminar(nuevoHistorial);
      return nuevoHistorial;
    });
    setIndice((prev) => prev + 1);
    setGirando(false);
  };

  const [confeti, setConfeti] = useState([]);

  useEffect(() => {
    if (!resultado) return;
    const piezas = Array.from({ length: 45 }, (_, i) => {
      const color = COLORS[Math.floor(Math.random() * COLORS.length)];
      return {
        id: i,
        left: Math.random() * 100,
        color: color === "#212529" ? "#ff9900" : color,
        delay: Math.random() * 0.4,
        duration: 2 + Math.random() * 0.8,
      };
    });
    setConfeti(piezas);
    const limpiar = setTimeout(() => setConfeti([]), 2200);
    return () => clearTimeout(limpiar);
  }, [resultado]);

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
   useEffect(() => {
    const cargar = async () => {
      try {
        const fase = new URLSearchParams(window.location.search).get('fase');
        const participantes = await getParticipantesSorteo(fase);
        setEstudiantes(participantes.data.data);
      } catch {
        setError('No se pudieron cargar los participantes.');
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, []);

  if (loading) {
    return (
      <>
        <style>{GLOBAL_STYLES}</style>
        <div className="ruleta-scroll" style={estilos.contenedor}>
          <div style={estilos.loaderWrapper}>
            <div className="ruleta-loader" style={estilos.loader} />
            <span>Cargando participantes...</span>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <style>{GLOBAL_STYLES}</style>
        <div className="ruleta-scroll" style={estilos.contenedor}>
          <div style={estilos.errorBox}>{error}</div>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{GLOBAL_STYLES}</style>
      <div className="ruleta-scroll" style={estilos.contenedor}>
        <div style={estilos.header}>
          <div style={{display:"flex", flexDirection:"row", gap:10, alignItems:'center'}}>
            <Image src={require('@assets/images/logo-gc-horizontal.png')} width={100} alt="logo"/>
            <Image src={require('@assets/images/uvegActualizado.png')} width={100} alt="logo"/>
          </div>
          <h2 style={estilos.headerTitulo}>Sorteo en vivo</h2>
          <p style={estilos.headerSubtitulo}>Revelando al siguiente participante</p>
        </div>

        <div className={`ruleta-grid${historial.length === 0 ? " ruleta-grid--solo" : ""}`}>
          <div className="ruleta-stage" style={estilos.stage}>
            <div style={estilos.progreso}>
              {terminado ? "Sorteo finalizado" : `Participante ${Math.min(indice + 1, total)} de ${total}`}
            </div>

            <div className="ruleta-ring" style={estilos.ruletaWrapper}>
              <div style={estilos.puntero} />
              <div
                style={{
                  ...estilos.ruleta,
                  background: fondoRuleta,
                  transform: `rotate(${rotacion}deg)`,
                  position: "relative",
                  zIndex: 1,
                }}
                onTransitionEnd={manejarFinGiro}
              />
              <div style={estilos.centro} />
              {confeti.length > 0 && (
                <div style={estilos.confetiCapa}>
                  {confeti.map((p) => (
                    <span
                      key={p.id}
                      className="ruleta-confeti"
                      style={{
                        left: `${p.left}%`,
                        backgroundColor: p.color,
                        animationDelay: `${p.delay}s`,
                        animationDuration: `${p.duration}s`,
                      }}
                    />
                  ))}
                </div>
              )}
            </div>

            <button
              className={`ruleta-boton-girar${!girando && !terminado ? " ruleta-boton-girar--idle" : ""}`}
              style={estilos.boton(girando || terminado)}
              onClick={girar}
              disabled={girando || terminado}
            >
              {girando ? "Girando..." : terminado ? "Sin más participantes" : "Girar ruleta"}
            </button>

            {!terminado && <p style={estilos.instruccion}>Presiona el botón para revelar el siguiente ganador</p>}
          </div>

          <div className="ruleta-panel" style={estilos.panel}>
            {resultado && (
              <div className="ruleta-resultado-card" style={estilos.tarjetaResultado}>
                <h3 style={estilos.tituloResultado}>
                  {resultado.nombreCompleto} {resultado.apellidos}
                </h3>
                <div style={estilos.filaResultado}>
                  <span style={estilos.etiqueta}>Lectura: </span>
                  <span> {resultado.tituloLectura ?? "Sin lectura"}</span>
                </div>
                <div style={estilos.filaResultado}>
                  <span style={estilos.etiqueta}>Plantel: </span>
                  <span> {resultado.plantel}</span>
                </div>
                <div style={estilos.filaResultado}>
                  <span style={estilos.etiqueta}>Municipio: </span>
                  <span> {resultado.municipio}</span>
                </div>
                <div style={estilos.filaResultado}>
                  <span style={estilos.etiqueta}>Docente: </span>
                  <span> {resultado.nombreDocente}</span>
                </div>
              </div>
            )}

            {terminado && historial.length > 0 && (
              <div style={estilos.finalizado}>Total procesados: {historial.length}</div>
            )}

            {historial.length > 0 && (
              <div className="ruleta-scroll" style={estilos.historialPanel}>
                {historial
                  .slice()
                  .reverse()
                  .map((h, i) => (
                    <div key={historial.length - i} style={estilos.historialItem}>
                      <span style={estilos.historialNombre}>
                        {h.nombreCompleto} {h.apellidos}
                      </span>
                      <span style={estilos.historialLectura}>{h.tituloLectura ?? "Sin lectura"}</span>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}